import { PaletteOptions } from '@mui/material/styles/createPalette';

declare module '@mui/material/styles/createPalette' {
  interface PaletteColor {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
  }

  interface Palette {
    error: PaletteColor;
    ghostWhite: PaletteColor;
    blue: PaletteColor;
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    error?: PaletteColorOptions;
    ghostWhite: PaletteColorOptions;
    blue: PaletteColorOptions;
  }
}

const colors: PaletteOptions = {
  primary: {
    main: '#269A05',
  },
  secondary: {
    main: '#FFFFFF',
  },
  ghostWhite: {
    main: '#FAFAFC',
  },
  blue: {
    main: '#ABB2C2',
  },
  text: {
    primary: '#14151A',
    secondary: '#50576B',
  },
  error: {
    main: '#F22525',
  },
};

export default colors;
